import { Nullable } from '@enmon/commons';
import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { SerializedInventoryMeter } from '@enmon/commons/lib/tools';
import { createContext, useContext } from 'react';

interface MeterContextShape {
  enmonMeter: Nullable<SerializedMeter>;
  inventoryMeter: Nullable<SerializedInventoryMeter>;
  isLoading: boolean;
}

export const MeterContext = createContext<MeterContextShape | undefined>(undefined);

export const useMeterContext = (): MeterContextShape => {
  const value = useContext(MeterContext);
  if (!value) throw new Error('useContextMeter must be used within MeterProvider');
  return value;
};
